import { Particle } from "../Particle";
import { MovesDown } from "../behaviors/MovesDown";
import { TemperatureNormalization } from "../behaviors/TemperatureNormalization";
import { PhaseChange } from "../behaviors/PhaseChange";
import { adjustColor } from "../../utils/color";
import { Lava } from "./Lava";

export class Sand extends Particle {
    static baseColor = 0xFFC247; // Rich Golden Sand

    constructor() {
        super({
            name: "Sand",
            color: adjustColor(Sand.baseColor, 25),
            behaviors: [
                new MovesDown(),
                new PhaseChange([
                    { temp: 1000, type: 'above', factory: () => new Lava({ temperature: 1000 }) }
                ]),
                new TemperatureNormalization(20, 0.1)
            ],
            temperature: 20,
            minTemp: -273,
            maxTemp: 3000,
            props: {
                isPowder: true
            }
        });
    }
}
